import { ReactNode } from 'react'

import {
  AlarmIcon,
  CameraIcon,
  type ColorScheme,
  DoorIcon,
  tokenVar,
} from '@hivewatch/dark'

import { DeviceType } from '@/graphql/generated/schemas'

/**
 * Leading detection-type icon for a device's incidents on the reskinned Recent
 * Incidents card, coloured for the active scheme. Mirrors the incident-drawer's
 * device-type icon mapping.
 */
export const getDeviceTypeIcon = (
  deviceType: DeviceType | undefined,
  colorScheme: ColorScheme
): ReactNode => {
  const color = tokenVar(
    colorScheme === 'light'
      ? 'colors.light.icon.secondary'
      : 'colors.icon.secondary'
  )
  switch (deviceType) {
    case DeviceType.Camera:
      return <CameraIcon color={color} size={16} />
    case DeviceType.Door:
      return <DoorIcon color={color} size={16} />
    default:
      return <AlarmIcon color={color} size={16} />
  }
}
